import { FC, useLayoutEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import { Cross } from '@assets/icons';
import Tooltip from '@components/tooltip/Tooltip';

type Props = {
  label: string;
  handleRemoveChip?: () => void;
  showTooltip?: boolean;
  showRemoveButton?: boolean;
};

const Chip: FC<Props> = props => {
  const {
    label,
    handleRemoveChip,
    showTooltip = false,
    showRemoveButton = true,
  } = props;

  const labelRef = useRef<HTMLDivElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const showTooltipForChip = showTooltip && isTruncated;

  useLayoutEffect(() => {
    if (labelRef.current) {
      setIsTruncated(
        labelRef.current.scrollWidth > labelRef.current.clientWidth,
      );
    }
  }, [label]);

  return (
    <Tooltip
      RefComponent={
        <div className="bg-gray-7 border-gray-15 border rounded-lg px-1 h-6 text-sm leading-4 max-w-[260px] flex items-center">
          <div
            ref={labelRef}
            className={twMerge(
              classNames(
                'text-text-secondary truncate whitespace-nowrap',
                showRemoveButton ? 'max-w-[90%]' : 'max-w-full',
              ),
            )}
          >
            {label}
          </div>
          {showRemoveButton && (
            <Cross
              className="w-4 h-4 ml-1 cursor-pointer text-text-secondary"
              onClick={handleRemoveChip}
            />
          )}
        </div>
      }
      tooltipText={showTooltipForChip ? label : undefined}
    />
  );
};

export default Chip;
